import { type FC } from 'react';

import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Label } from '@wf/sw-ui-kit';

import Separator from '../../../../components/Separator';
import { LicenseField } from '../LicenseField';

import { getFloatingNumberRegexp } from '../../../../constants/regex';
import { HeaderTabFields } from '../../types/fieldEnums';

import { featureFlagsSelector, fieldConfigsSelector } from '../../store/selectors';
import { configsSelector } from '../../../../store/configs/selectors';
import { fieldNameConverter } from '../../helpers/fieldNameConverter';
import { RimmEntityType } from '../../../rimm/data/rimmEntityEnums';

import styles from './HeaderTab.module.scss';

const TermOfDeliveryAndInvoice: FC = () => {
  const { t } = useTranslation();
  const fieldConfigs = useSelector(fieldConfigsSelector);
  const featureFlags = useSelector(featureFlagsSelector);
  const configs = useSelector(configsSelector);

  const termOfDeliveryEnabled = fieldConfigs[fieldNameConverter(HeaderTabFields.termsOfDeliveryCode)]?.hidden === false;
  const invoiceValueManagementEnabled = featureFlags?.invoiceValueManagementEnabled;

  if (!termOfDeliveryEnabled && !invoiceValueManagementEnabled) {
    return null;
  }

  return (
    <>
      <Separator className="grid-full-width" />
      <LicenseField.RimmSelectField
        label={
          <Label
            helpText={t(
              'Incoterm codes defining the responsibilities of exporters and importers regarding shipments and the transfer of liability involved at various stages of goods movement'
            )}
          >
            {t('Terms of Delivery')}
          </Label>
        }
        configName={HeaderTabFields.termsOfDeliveryCode}
        name={HeaderTabFields.termsOfDeliveryCode}
        entity={RimmEntityType.termsOfDelivery}
        placeholder={t('Select...')}
        withTag
      />
      <LicenseField.RimmSelectField
        label={
          <Label helpText={t('Currency code used in the invoice for the import or export of goods')}>
            {t('Invoice Currency Code')}
          </Label>
        }
        configName={HeaderTabFields.invoiceCurrencyCode}
        name={HeaderTabFields.invoiceCurrencyCode}
        entity={RimmEntityType.exchangeRate}
        placeholder={t('Select...')}
        //TODO fix type issue
        //@ts-expect-error
        tagKey="rate"
        withTag
      />

      <LicenseField.TextField
        label={
          <Label helpText={t('Total Value of the invoice for the goods in foreign currency')}>
            {t('Invoice Value in Foreign Currency')}
          </Label>
        }
        configName={HeaderTabFields.invoiceAmountInForeignCurrency}
        name={HeaderTabFields.invoiceAmountInForeignCurrency}
        placeholder={t('Invoice Value in Foreign Currency')}
        regexp={getFloatingNumberRegexp(2)}
        className={styles.firstColumn}
        formatAsNumber
      />
      <LicenseField.TextField
        label={
          <Label helpText={t('Total Value of the invoice for the goods in national currency')}>
            {t('Invoice value in {{currencyName}}', { currencyName: configs?.nationalCurrency })}
          </Label>
        }
        configName={HeaderTabFields.invoiceAmountInNationalCurrency}
        name={HeaderTabFields.invoiceAmountInNationalCurrency}
        placeholder={t('Invoice Value in National Currency')}
        regexp={getFloatingNumberRegexp(2)}
        formatAsNumber
      />
    </>
  );
};

export default TermOfDeliveryAndInvoice;
